import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { LocalDeviceDetectorService } from 'dmmp-services'

@Component({
  selector: 'dmmp-website-footer',
  templateUrl: './website-footer.component.html'
})
export class WebsiteFooterComponent implements OnInit {

  @Input() identifier
  @Input() data
  @Output() anchorCustom = new EventEmitter()
  @Input() menus
  @Output() page = new EventEmitter()

  constructor(public localDeviceDetector: LocalDeviceDetectorService) {
  }

  ngOnInit() {
    this.menus?.sistemap?.forEach(menu => {
      menu.isCollapse = true
    })
  }

  ancla(event) {
    this.anchorCustom.emit(event)
  }

  anclaValidate(event, data) {
    if (data?.indexOf('#') === 0 && data?.length > 1) {
      this.anchorCustom.emit({event: event, id: data})
    }
  }

}
